import { useEffect } from "react";

let dismissOpenSheet: (() => void) | null = null;

export const getDismissOpenSheet = () => dismissOpenSheet;

export const useDismissSheet = (isOpen: boolean, close: () => void) => {
  useEffect(() => {
    if (isOpen) {
      dismissOpenSheet = close;
      return () => {
        dismissOpenSheet = null;
      };
    }
  }, [isOpen, close]);
};
